import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ShareFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M16.5 9a3.5 3.5 0 10-3.472-3.054L7.966 9.321a3.5 3.5 0 10.67 5.951l4.39 2.794a3.5 3.5 0 10.82-1.849l-4.038-2.57c.124-.36.192-.745.192-1.147 0-.658-.182-1.274-.498-1.8l4.356-2.904A3.492 3.492 0 0016.5 9z",
    clipRule: "evenodd"
  }));
}

export default ShareFill;